import React from 'react';
import { ZdsIcon } from '@zig-design-system/ui-components-react';
export const Label = ({ field }) => {
    if (field.hideTitle) {
        return null;
    }
    return (React.createElement("div", { slot: "label", className: "zds-flex zds-items-center zds-gap-2" },
        field.title,
        field.description && (React.createElement(ZdsIcon, { id: `powermail_field_${field.marker}_info`, library: "fa-solid", name: "circle-info", size: "sm", class: "zds-color-info" }))));
};
